import { useMemo } from "react";

import { AnimatedBackground } from "@components/landing/HeroCard/AnimatedBackground";
import { generateOpacityMatrix } from "@components/landing/HeroCard/utils";

export const SVGDemo = () => {
  const width = 1200;
  const height = 300;
  const animatedBackgroundGridSize = 10;
  const columns = width / animatedBackgroundGridSize;
  const rows = height / animatedBackgroundGridSize;

  const opacityMatrix = useMemo(
    () => generateOpacityMatrix(columns, rows),
    [columns, rows],
  );

  return (
    <div className="w-full overflow-hidden">
      <AnimatedBackground
        columns={columns}
        rows={rows}
        opacityMatrix={opacityMatrix}
        gradient
        width={width}
        height={height}
      />
    </div>
  );
};
